module.exports = __webpack_public_path__ + "static/media/5J1A6597_Small.28dd8c86.jpg";